module.exports = __webpack_public_path__ + "static/media/Dr. Amitoj Athwal.fec0a05e.png";